import { render, staticRenderFns } from "./Password ResetSent.vue?vue&type=template&id=a3c457b6&scoped=true&"
import script from "./Password ResetSent.vue?vue&type=script&lang=js&"
export * from "./Password ResetSent.vue?vue&type=script&lang=js&"
import style0 from "./Password ResetSent.vue?vue&type=style&index=0&id=a3c457b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c457b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VFlex,VLayout})
